export const SET_DRIVER = 'SET_DRIVER'
export const SET_DRIVER_LOCATION = 'SET_DRIVER_LOCATION'

